module.exports = __webpack_public_path__ + "img/transportationResources.c867d6aa.png";